import type { ReactNode } from 'react';

// One line-art glyph for every empty/error state, so they read as a family.
export function EmptyState({ title, hint, action, tone }: { title: string; hint?: string; action?: ReactNode; tone?: 'error' }) {
  return (
    <div className={`empty${tone === 'error' ? ' empty-error' : ''}`}>
      <svg className="empty-glyph" width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden>
        <rect x="10" y="14" width="52" height="44" rx="8" stroke="currentColor" strokeWidth="2" opacity=".35" />
        <path d="M10 26h52" stroke="currentColor" strokeWidth="2" opacity=".35" />
        <circle cx="18" cy="20" r="1.8" fill="currentColor" opacity=".5" />
        <circle cx="24" cy="20" r="1.8" fill="currentColor" opacity=".5" />
        <path d="M26 44c2.5-4 5.5-6 10-6s7.5 2 10 6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        <circle cx="29" cy="35" r="1.6" fill="currentColor" /><circle cx="43" cy="35" r="1.6" fill="currentColor" />
      </svg>
      <div className="empty-title">{title}</div>
      {hint && <div className="empty-hint">{hint}</div>}
      {action && <div className="empty-action">{action}</div>}
    </div>
  );
}

/** Inline fetch-failure state for list pages. */
export function LoadFailed({ what }: { what: string }) {
  return (
    <EmptyState
      tone="error"
      title={`Couldn't load ${what}`}
      hint="The API returned an error or an unexpected response. Try again; if it keeps happening, the AI Expo backend may be down or misconfigured."
      action={<button type="button" className="dv-btn" onClick={() => window.location.reload()}>Retry</button>}
    />
  );
}
